import React, { memo } from 'react';
import PropTypes from 'prop-types';
var CommonWrapper = function CommonWrapper(_ref) {
  var children = _ref.children,
    showErrors = _ref.showErrors,
    wrapperClassName = _ref.wrapperClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(wrapperClassName, " ").concat(showErrors ? 'has-error' : '')
  }, children);
};
CommonWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  showErrors: PropTypes.bool.isRequired,
  wrapperClassName: PropTypes.string
};
CommonWrapper.defaultProps = {
  wrapperClassName: ''
};
export default /*#__PURE__*/memo(CommonWrapper);